import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/symfony': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM389.7 151.5c15.3-0.5 19.8-15.4 19.5-23.1-0.6-18.1-19.7-29.5-44.8-28.7-1.9 0.1-65.3-3.5-102.4 105.5-10.1-8.3-57.8-65.2-110.6-25.8-19 14.2-31.4 47.9-3 79.7 17 18.1 26.7 25.3 22.3 39.8-9.1 29.8-55.6 16.2-51 1.4 1.4-4.4 3.5-4.5 6.3-13.1 7.7-25.3-27.1-37.8-34.6-13.6-4.3 14.1 2.4 39.5 38.4 50.6 42.2 13 77.8-10 82.9-39.9 3.2-18.8-5.3-32.7-20.8-50.6l-12.6-14c-7.7-7.7-10.3-20.7-2.4-30.7 6.7-8.5 16.2-12.1 31.8-7.8 22.8 6.2 32.9 22 49.8 34.7-1.2 4-10 32.3-18.2 82-12.1 63.5-21.3 98.4-45.3 118.4-4.8 3.5-11.8 8.6-22.2 9-1.9 0.1-14.1-2.8-2-12.6 15.2-8.3 7-34.8-14.9-34-9.9 0.3-24.9 9.6-24.3 26.6 0.6 17.5 16.9 30.7 41.6 29.8 13.2-0.4 42.6-5.8 71.6-40.3 39.8-46.7 47.4-102.2 58.2-161.7 51.7 6.1 77.2-17.8 77.6-35.7 0.5-24.3-28-23.5-32-5.3-1.9 8.8 13.4 16.8 1.4 24.6-8.5 5.5-23.7 9.4-45.1 6.2 10.3-56.8 19.1-112.6 58.9-113.8 2.7-0.2 12.6 0.1 12.9 6.7 0.2 5.4-6.8 9.7-6.5 18.8 0.4 10.4 8.3 17.3 19.8 16.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/symfony.js
// module id = 1048
// module chunks = 0